import { sessionCheckQueryOption, useCustomQuery } from 'src/hooks/react-query/useCustomQuery.hook'
import { useCookies } from 'react-cookie'
import { DateUtils } from 'src/utils/date'
import { useEffect } from 'react'
import useCustomCookies from 'src/hooks/useCustomCookies.hook'
import usePageNav from 'src/hooks/usePageNav.hook'
import { logoutQueryOption, useCustomMutation } from 'src/hooks/react-query/useCustomMutation.hook'
import { Bridge } from 'src/utils/bridge'
import { useLocation } from 'react-router-dom'
import useUserInfo from 'src/hooks/useUserInfo'
import { useChannel } from 'src/provider/ChannelContextProvider'

const useSessionCheck = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [cookies, setCookie, _removeCookie] = useCookies(['auth-key', 'u-tel'])
  const { removeAllCookies } = useCustomCookies()
  const { joinPageNav, introPageNav } = usePageNav()
  const { mutateAsync: logoutMutate } = useCustomMutation(logoutQueryOption())
  const { sessionCookieOptions } = DateUtils
  const { c_tel } = useCustomCookies()
  const { pathname } = useLocation()
  const { resavePNumber } = useUserInfo()
  const { web } = useChannel()

  const replaceAllPathname = window.location.pathname?.replaceAll('/', '')

  const onlyChannelPath =
    replaceAllPathname === 'web' || replaceAllPathname === 'aos' || replaceAllPathname === 'ios'
  const isNotBillgatePage = !window.location.pathname?.includes('billgate')
  const isNotDanalPage = !window.location.pathname?.includes('danal')
  const isNotPaymentFinishPage = !window.location.pathname?.includes('payment/finish')
  const isNotSplashPage = !window.location.pathname?.includes('splash')
  const isNotJoinPage = !window.location.pathname?.includes('join')
  const isNotCancelCompletePage = !window.location.pathname?.includes('cancel/complete')
  const isNotErrorPage = !window.location.pathname?.includes('error')
  const isNotSystemNoticePage = !window.location.pathname?.includes('system_notice')
  const isNotPassPage = !window.location.pathname?.includes('pass')
  const isNotPassFinishPage = !window.location.pathname?.includes('pass/finish')
  const isNotGiftCardPage = !window.location.pathname?.includes('giftcard')
  const isNotPreviewPage = !window.location.pathname?.includes('preview')

  const isNotIntroPage = !window.location.pathname?.includes('intro')

  const isSessionCheckPage =
    isNotBillgatePage &&
    isNotDanalPage &&
    isNotCancelCompletePage &&
    isNotErrorPage &&
    isNotSystemNoticePage &&
    isNotSplashPage &&
    isNotPaymentFinishPage &&
    isNotJoinPage &&
    isNotPassPage &&
    isNotPassFinishPage &&
    isNotGiftCardPage &&
    isNotPreviewPage &&
    !onlyChannelPath

  const { isRefetching: isSessionRefetching } = useCustomQuery(
    sessionCheckQueryOption(isSessionCheckPage),
  )

  useEffect(() => {
    Bridge.receiveResetPinSession(() => {
      introPageNav()
      joinPageNav()
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (isSessionRefetching) {
      setCookie('auth-key', cookies['auth-key'], sessionCookieOptions())
      setCookie('u-tel', cookies['u-tel'], sessionCookieOptions())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSessionRefetching])

  useEffect(() => {
    if (isSessionCheckPage && !c_tel) {
      if (web) {
        introPageNav()
      } else {
        isNotIntroPage && resavePNumber()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, c_tel])
}
export default useSessionCheck
